import { render, staticRenderFns } from "./QuoteDetail.vue?vue&type=template&id=6be37e98&"
import script from "./QuoteDetail.vue?vue&type=script&lang=js&"
export * from "./QuoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuoteDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports